import React from "react";
import { Select } from "antd";
import "../SpecManagerSelect.css";

export default function SpecManagerSelect({
  options = [],
  selectedValue,
  placeholder,
  variant = "default",
  onSelect,
}) {
  const normalizedOptions = options.map((option) => {
    if (typeof option === "string") {
      return { value: option, label: option };
    }
    const labelText = option.label != null ? option.label : option.value;
    return {
      value: option.value,
      label: option.iconSrc ? (
        <span className="SpecManager_SelectOption">
          <img src={option.iconSrc} alt="" className="SpecManager_SelectOptionIcon" aria-hidden />
          <span>{labelText}</span>
        </span>
      ) : labelText,
    };
  });

  return (
    <Select
      className={`SpecManager_Select${variant === "borderless" ? " SpecManager_Select--borderless" : ""}`}
      popupClassName="SpecManager_SelectDropdown"
      placeholder={placeholder}
      value={selectedValue || undefined}
      options={normalizedOptions}
      onChange={onSelect}
      getPopupContainer={() => document.body}
    />
  );
}
